/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 追加権限
 * @export
 * @enum {number}
 */
export enum PermissionEnum {
    /** 個人情報閲覧 */
    PERSONAL_INFO_VIEW = 1,
    /** 配車 */
    DISPATCH = 2,
    /** マスター登録 */
    MASTER_REGISTRATION = 3,
    /** 返金 */
    REFUND = 4
}

/**
 * 追加権限 の Union 型
 * @export
 * @typedef Permission
 */
export type Permission =
  typeof PermissionEnum[keyof typeof PermissionEnum];

/**
 * 追加権限 のラベルマップ
 * @export
 */
export const PermissionLabels = {
    /**
     * 数値キー: PermissionEnum.PERSONAL_INFO_VIEW
     * 名前キー:  PERSONAL_INFO_VIEW
     */
    [PermissionEnum.PERSONAL_INFO_VIEW]: '個人情報閲覧',
    PERSONAL_INFO_VIEW:                             '個人情報閲覧',
    /**
     * 数値キー: PermissionEnum.DISPATCH
     * 名前キー:  DISPATCH
     */
    [PermissionEnum.DISPATCH]: '配車',
    DISPATCH:                             '配車',
    /**
     * 数値キー: PermissionEnum.MASTER_REGISTRATION
     * 名前キー:  MASTER_REGISTRATION
     */
    [PermissionEnum.MASTER_REGISTRATION]: 'マスター登録',
    MASTER_REGISTRATION:                             'マスター登録',
    /**
     * 数値キー: PermissionEnum.REFUND
     * 名前キー:  REFUND
     */
    [PermissionEnum.REFUND]: '返金',
    REFUND:                             '返金',
} as const;

/**
 * 追加権限 のラベル Union 型
 * @export
 * @typedef PermissionLabel
 */
export type PermissionLabel =
  typeof PermissionLabels[keyof typeof PermissionLabels];

/**
 * 追加権限 のラベル取得関数
 * @export
 * @param { Permission } value - 列挙体の値
 * @returns { PermissionLabel } ラベル文字列
 */
export function getPermissionLabel(
  value: Permission
): PermissionLabel {
  return PermissionLabels[value];
}

/**
 * 追加権限 のラベル配列を取得する関数
 * @export
 * @param { Permission[] } values - 列挙体の値配列
 * @returns { PermissionLabel[] } ラベル文字列配列
 */
export function getPermissionLabels(values: Permission[]): PermissionLabel[] {
  return values.map((value) => getPermissionLabel(value));
}

/**
 * 追加権限 のラベル配列
 * @export
 */
export const PermissionLabelList = [
  '個人情報閲覧','配車','マスター登録','返金',
] as const;

